<template>
  <div>
    <b-tabs content-class=""
            class="Genitor-border"
            lign="left"
            bottom
            active-nav-item-class="Genitor--tab-active">
      <b-tab class="contentGenitor"
             @click="formContent('genitor')">
        <template v-slot:title>
          Genitor
        </template>
        <form name="formAddGenitor"
              class="mt-4 mb-3"
              novalidate>
          <div class="row">
            <div class="col-sm-2 col-md-2">
              <div class="form-group">
                <label class="label"
                       :for="`cpf-${id}`">CPF</label>
                <input :id="`cpf-${id}`"
                       ref="cpf_genitor"
                       v-model="formGenitor.pessoa.cpf"
                       v-validate="{ regex: /\d{3}\.\d{3}\.\d{3}-\d{2}$/ }"
                       v-mask="{ mask: '999.999.999-99' }"
                       :class="{ 'is-invalid': errors.has('cpf') }"
                       class="form-control form-control-sm"
                       name="cpf"
                       placeholder="000.000.000-00"
                       type="tel"
                       @change="searchCPF">
                <small v-if="errors.has('cpf')"
                       class="invalid-feedback">{{ errors.first('cpf') }}</small>
              </div>
            </div>
            <div class="col-sm-6 col-md-6">
              <div class="form-group">
                <label class="label"
                       :for="`nomeGenitor-${id}`">Nome do Genitor<span v-if="propValidate"
                                                                       class="text-danger"> * </span></label>
                <input :id="`nomeGenitor-${id}`"
                       v-model.lazy="formGenitor.pessoa.nome"
                       v-validate="{ required: true }"
                       v-uppercase
                       :class="{ 'is-invalid': errors.has('nomeGenitor') }"
                       class="form-control form-control-sm text-uppercase"
                       name="nomeGenitor"
                       placeholder="Manuelina Terebentina"
                       type="text"
                       @change="validateInputs('nomeGenitor')">
                <small v-if="errors.has(`nomeGenitor-${id}`)"
                       class="invalid-feedback">{{ errors.first(`nomeGenitor-${id}`) }}</small>
              </div>
            </div>
            <div class="col-2">
              <div class="form-group">
                <label class="label"
                       for="sexoGenitor">Sexo <span v-if="propValidate"
                                                    class="text-danger"> * </span></label>
                <select v-if="!propNascimento"
                        id="sexoGenitor"
                        v-model="formGenitor.pessoa.sexo"
                        v-validate="{ required: true }"
                        :class="{ 'is-invalid': errors.has('sexoGenitor') }"
                        class="custom-select custom-select-sm"
                        name="sexoGenitor"
                        @change="validateInputs('sexoGenitor')">
                  <small v-if="errors.has('sexoGenitor')"
                         class="invalid-feedback">{{ errors.first('sexoGenitor') }}</small>
                  <option selected
                          value="">
                    Selecione
                  </option>
                  <option v-for="sex in SEXOS"
                          :key="sex.value"
                          :value="sex.value">
                    {{ sex.name }}
                  </option>
                </select>
                <select v-if="propNascimento"
                        id="sexoGenitor"
                        v-model="formGenitor.pessoa.sexo"
                        v-validate="{ required: true }"
                        :class="{ 'is-invalid': errors.has('sexoGenitor') }"
                        class="custom-select custom-select-sm"
                        name="sexoGenitor"
                        @change="validateInputs('sexoGenitor')">
                  <option selected
                          value="">
                    Selecione
                  </option>
                  <option value="M">
                    Masculino
                  </option>
                  <option value="F">
                    Feminino
                  </option>
                </select>
                <small v-if="errors.has('sexoGenitor')"
                       class="invalid-feedback">{{ errors.first('sexoGenitor') }}</small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-2">
              <div class="form-group">
                <label for="data_nascimento_genitor"
                       class="label">
                  Data de Nascimento
                </label>
                <input id="data_nascimento_genitor"
                       v-model="formGenitor.pessoa.data_nascimento"
                       v-mask="`99/99/9999`"
                       v-validate="`date_format:yyyy-MM-dd|date_between:1500-01-01,${limitDate}`"
                       :class="{ 'is-invalid': errors.has('data_nascimento_genitor') }"
                       class="form-control form-control-sm"
                       name="data_nascimento_genitor"
                       placeholder="00/00/0000"
                       type="date"
                       @input="nascimentoHandler">
                <small v-if="errors.has('data_nascimento_genitor')"
                       class="invalid-feedback">{{ errors.first('data_nascimento_genitor') }}</small>
              </div>
            </div>

            <div class="col-2">
              <div class="form-group">
                <label for="genitor_idade"
                       class="label">
                  Idade
                </label>
                <input id="genitor_idade"
                       v-model="formGenitor.pessoa.idade"
                       type="number"
                       :disabled="true"
                       class="form-control form-control-sm">
                <small class="text-secondary">
                  <b>Idade calculada</b> com base na <b>data de nascimento</b>.
                </small>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label class="label"
                       for="ocupacao_declarada">Profissão</label>
                <input id="ocupacao_declarada"
                       v-model="formGenitor.pessoa.ocupacao_declarada"
                       class="form-control form-control-sm"
                       name="ocupacao_declarada"
                       placeholder="Ex: Padeiro"
                       type="text"
                       @change="ocupacaoChanged">
              </div>
            </div>

            <div class="col-3">
              <div class="form-group">
                <label class="label"
                       for="genitor_profissao_cbo">
                  Profissão Correspondente CBO
                </label>
                <ProfissoesCBO v-model="formGenitor.pessoa.ocupacao_codigo"
                               :pre-load="profissaoPreload"
                               :ocupacao="formGenitor.pessoa.ocupacao"
                               @changed="updateProfissao" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <div class="form-group">
                <label class="label"
                       for="nacionalidadeDeclarante">Nacionalidade</label>
                <Nacionalidades id="nacionalidadeDeclarante"
                                v-model="formGenitor.pessoa.nacionalidade_codigo"
                                :prop-nacionalidade="formGenitor.pessoa.nacionalidade"
                                :prop-sexo="formGenitor.pessoa.sexo"
                                :label-key="sexo"
                                @updated="changeNacionalidade" />
              </div>
            </div>

            <div class="col-2">
              <div class="form-group">
                <label class="label"
                       :for="`uf-${id}`">UF</label>

                <v-select :id="`uf-${id}`"
                          v-model="formGenitor.pessoa.uf"
                          class="form-control form-control-sm"
                          name="estadoGenitor"
                          :options="selectsOptions.states.map((state)=>state.uf)"
                          @input="ufChanged" />
                <small class="invalid-feedback">{{ errors.first('estadoGenitor') }}</small>
              </div>
            </div>
            <div class="col-sm-5 col-md-4">
              <div class="form-group">
                <label class="label"
                       :for="`naturalidade-${id}`">Naturalidade </label>
                <v-select :id="`naturalidade-${id}`"
                          v-model="formGenitor.pessoa.naturalidade"
                          name="naturalidade"
                          class="form-control form-control-sm"
                          placeholder="Selecione"
                          :searchable="formGenitor.pessoa.uf !== 'EX'"
                          :taggable="formGenitor.pessoa.uf !== 'EX'"
                          :options="citiesFiltered.map((city)=>city.nome)"
                          @input="changed" />
              </div>
            </div>
            <div v-if="formGenitor.pessoa.naturalidade == 'Outro'"
                 class="col-sm-3 col-md-3">
              <div class="form-group">
                <label class="label"
                       :for="`genitor-${id}`">Naturalidade Declarada </label>
                <input :id="`genitor-${id}`"
                       v-model.lazy="formGenitor.pessoa.naturalidade_declarada"
                       class="form-control form-control-sm"
                       name="naturalidade_declarada"
                       placeholder="Cidade declarada"
                       type="text"
                       @changed="changed">
              </div>
            </div>
            <div class="col-auto mt-sm-3 pt-sm-3">
              <div class="form-group">
                <span class="custom-control custom-switch">
                  <input :id="`GenitorFalecido_${ _uid }-${toEdit && 'editForm'}`"
                         v-model="formGenitor.pessoa.falecido"
                         class="custom-control-input"
                         :name="`GenitorFalecido-${toEdit && 'editForm'}`"
                         type="checkbox"
                         @change="changed"
                         @keydown.enter="(event) => changeFalecido(event.target.value)">
                  <label class="custom-control-label"
                         :for="`GenitorFalecido_${ _uid }-${toEdit && 'editForm'}`">Falecido</label>
                </span>
              </div>
            </div>

            <div v-if="campoDeclarante"
                 class="col-auto mt-sm-3 pt-sm-3">
              <div class="form-group">
                <span class="custom-control custom-switch">
                  <input :id="`GenitorDeclarante_${ _uid }-${toEdit && 'editForm'}`"
                         v-model="formGenitor.declarante"
                         class="custom-control-input"
                         :name="`GenitorDeclarante-${toEdit && 'editForm'}`"
                         type="checkbox"
                         :disabled="!!formGenitor.pessoa.falecido"
                         @change="changed"
                         @keydown.enter="(event) => changeDeclarante(event.target.value)">
                  <label class="custom-control-label"
                         :for="`GenitorDeclarante_${ _uid }-${toEdit && 'editForm'}`">Declarante</label>
                </span>
              </div>
            </div>
          </div>
        </form>
      </b-tab>
      <b-tab class="contentDocumentos"
             @click="formContent('documentos')">
        <template v-slot:title>
          Documentos
        </template>
        <div class="px-2 mt-4 mb-2">
          <form name="formAddDocs">
            <Documentos :pessoa-id="formGenitor.pessoa.pessoa_id"
                        :documentos="formGenitor.pessoa.documentos"
                        :prop-hide-swal="true"
                        @DocumentoAdded="getDocumentos"
                        @DocumentoRemoved="removeDocumento" />
          </form>
        </div>
      </b-tab>
      <b-tab class="contentEndereco"
             @click="formContent('endereco')">
        <template v-slot:title>
          Endereço
        </template>
        <div v-if="!toEdit"
             class="mt-4 mb-3">
          <span v-if="enderecoRegistrado && Object.entries(enderecoRegistrado).length"
                class="custom-control custom-radio custom-control-inline">
            <input :id="`mesmoDoRegistrado_${ _uid }`"
                   v-model="predefineAddress"
                   type="radio"
                   :value="enderecoRegistrado"
                   :name="`mesmoDoRegistrado_${ _uid }`"
                   class="custom-control-input"
                   @change="setPredefineAddress"
                   @keyup.enter="setMesmoDoRegistro(enderecoRegistrado)">
            <label class="custom-control-label"
                   :for="`mesmoDoRegistrado_${ _uid }`">Mesmo do Registrado</label>
          </span>
          <span v-for="(gen, index) in enderecosDisponiveis"
                :key="index"
                class="custom-control custom-radio custom-control-inline">
            <input :id="`mesmoDoGenitor-${gen.pessoa.nome}-${_uid}-${index}`"
                   v-model="predefineAddress"
                   type="radio"
                   :name="`mesmoDoGenitor-${gen.pessoa.nome}-${_uid}-${index}`"
                   :value="gen.pessoa.endereco"
                   :class="`custom-control-input endereco-${index}`"
                   @change="setPredefineAddress"
                   @keyup.enter="setMesmoDoRegistro(gen.pessoa.endereco)">
            <label class="custom-control-label"
                   :for="`mesmoDoGenitor-${gen.pessoa.nome}-${_uid}-${index}`">O mesmo de {{ gen.pessoa.nome }}</label>
          </span>
          <span class="custom-control custom-radio custom-control-inline">
            <input :id="`novo_${ _uid }`"
                   v-model="predefineAddress"
                   type="radio"
                   :value="{}"
                   :name="`novo_${ _uid }`"
                   class="custom-control-input novo-enderecos"
                   @change="setNullAddress"
                   @keyup.enter="setMesmoDoRegistro({})">
            <label class="custom-control-label"
                   :for="`novo_${ _uid }`">Novo</label>
          </span>
        </div>

        <BoxEndereco :prop-mostrar-exterior="true"
                     :prop-cartorio="propCartorio"
                     :no-header="true"
                     :data="formGenitor.pessoa.endereco"
                     @onEnderecoAdd="getAddress" />
      </b-tab>
      <b-tab v-if="propTipoRegistro === 'N'"
             class="contentAvos"
             @click="formContent('avos')">
        <template v-slot:title>
          Ascendentes ({{ countAvos() }} {{ countAvos() > 1 ? 'preenchidos' : 'preenchido' }})
        </template>
        <div class="Avo-body">
          <div v-for="(avo, index) in formGenitor.filiacao"
               :key="index">
            <div class="form-group">
              <div class="row">
                <div class="col-12 Avo-title">
                  <label :for="`linha-avos-${index}`"
                         class="label Avo-label">
                    Ascendente - {{ index + 1 }}
                  </label>
                  <hr :id="`linha-avos-${index}`"
                      class="Avo-hr">
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <label :for="`nome-avo-${index}`"
                         class="label Avo-label-nome">
                    Nome Completo
                  </label>
                  <input :id="`nome-avo-${index}`"
                         v-model="avo.nome"
                         type="text"
                         class="form-control form-control-sm text-uppercase"
                         :name="`avo-${index}`"
                         @change="changed">
                </div>
                <div class="col-2 d-flex align-items-end">
                  <button class="btn btn-sm btn-outline-danger Avo-btn-eraser-avo"
                          @click="clearAvo(avo, index)">
                    <IconSvg class="Avo-icon-eraser"
                             icon="eraser" />
                    Limpar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <button class="btn btn-outline-primary Avo-btn-add-avos"
                    :disabled="disableButton()"
                    @click="addAvo()">
              <IconSvg class="Avo-icon-add"
                       icon="add" />
              Adicionar mais Ascendentes
            </button>
          </div>
        </div>
      </b-tab>
      <b-tab v-if="formGenitor.pessoa.falecido"
             class="addressFalecimento"
             @click="formContent('addressFalecimento')">
        <template v-slot:title>
          Local de falecimento
        </template>
        <div>
          <BoxEndereco v-if="formGenitor && formGenitor.localOcorrenciaFalecimento"
                       :prop-mostrar-exterior="true"
                       :prop-cartorio="propCartorio"
                       :prop-genitor-falecido="true"
                       :endereco-disable="false"
                       :no-header="true"
                       :data="formGenitor.localOcorrenciaFalecimento.endereco"
                       :prop-local-falecimento="formGenitor.localOcorrenciaFalecimento"
                       @onEnderecoAdd="(address) => getAddressFalecido(address)"
                       @onDataFalecimentoAdd="(data) => getDataFalecimento(data)" />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import SEXOS from "@/constants/sexos"

  /* services */
  import PessoasService from "@/services/Pessoas"

  /* filters */
  import { filterDate, filterMaskedNumber } from '@/filters/filters'

  /* components */
  import ProfissoesCBO from '@/components/SofiaRei/ProfissoesCBO'
  import Documentos from '@/components/SofiaRei/Obito/Passos/Sessoes/Documentos'
  import Nacionalidades from "@/components/SofiaRei/Nacionalidades"
  import BoxEndereco from '@/components/SofiaRei/BoxEndereco.vue'

  /* libraries */
  import moment from "moment"

  /* constants */
  import BrazilianStates from "@/constants/brazilianStates"
  import Cidades from "@/constants/repositorio/cidades"

  export default {
    name: 'FormGenitor',
    components: { ProfissoesCBO, Documentos, Nacionalidades, BoxEndereco},
    props: {
      genitor: { type: Object, default: () => ({})},
      enderecoRegistrado: { type: Object, default: () => {}},
      genitores: { type: Array, default: () => [] },
      toEdit: { type: Boolean, default: false},
      campoDeclarante: { type: Boolean, default: false },
      propCartorio: { type: Object, default: () => { return {} }},
      propValidate: { type: Boolean, default: false, },
      propNascimento: { type: Boolean, default: false },
      propPredefineAddress: { type: Object, default: () => ({})},
      propTipoRegistro: { type: String, default: () => ('')},
      propData: { type: Object, default: () => ({}) }
    },
    inject: ['$validator'],
    data () {
      return {
        id: null,
        selectsOptions: {
          states: [...BrazilianStates],
          cities: []
        },
        citiesFiltered: [],
        SEXOS,
        data_nascimento: null,
        formGenitor: {
          filiacao: [
            { nome: '' },
            { nome: '' }
          ],
          localOcorrenciaFalecimento: {
            tipo: 'OUTRO',
            endereco: {}
          },
          pessoa: {
            cpf: null,
            sexo: null,
            nome: null,
            endereco: {},
            documentos: [],
            data_nascimento: null,
            idade: 0,
            codigo_ocupacao: [],
            nacionalidade_codigo: 76,
            nacionalidade: {
              nacionalidade_codigo: 76,
              nome: 'Brasil',
              nome_masculino: 'brasileiro',
              nome_feminino: 'brasileira'
            },
            falecido: false
          },
          declarante: false
        },
        predefineAddress: {},
        profissaoPreload: '',
        tab_atual: 0,
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD')
      }
    },
    computed: {
      enderecosDisponiveis () {
        return this.genitores.filter(genitor => {
          if ((this.enderecoRegistrado && genitor.pessoa && genitor.pessoa.endereco) && genitor.pessoa.endereco != this.enderecoRegistrado) {
            return true
          }
          return false
        })
      },

      sexo () {
        if (this.formGenitor.pessoa.sexo && this.formGenitor.pessoa.sexo == 'F') return 'nome_feminino'

        return 'nome_masculino'
      }
    },
    watch: {
      propPredefineAddress () {
        this.predefineAddress = this.propPredefineAddress
        this.tab_atual = 0
      },
    },
    mounted () {
      this.controlEvent().addEvent()

      this.id = this._uid

      this.predefineAddress = {}

      this.getDados()

      setTimeout(() => {
        this.$refs.cpf_genitor.focus()
      }, 100)
    },
    created () {
      this.getDados()

      this.ocupacao = this.formGenitor.pessoa.ocupacao

      this.changed()

      this.init()
    },
    methods: {
      init () {
        const splitDate = function (date) {
          return date && date.split('/').reverse().join('-') || null
        }

        // tratamos a data de verificacao
        if (Object.values(this.propData).length && this.propData.registro.pessoa.data_nascimento) {
          let dataLimite = null
          switch (this.propTipoRegistro) {
          // para nascimento que a data vem ##/##/####
          case "N":
            dataLimite = splitDate(this.propData.registro.pessoa.data_nascimento) || null
            break

          // para obito que a data vem ##/##/####
          case "O":
            dataLimite = splitDate(this.propData.registro.pessoa.data_nascimento) || null
            break

          // o comum é ####-##-##
          default:
            dataLimite = this.propData.registro.pessoa.data_nascimento || null
            break
          }

          if (!!dataLimite) {
            this.limitDate = dataLimite
          }
        }
      },

      setMesmoDoRegistro (val) {
        this.predefineAddress = { ...val }
        this.formGenitor.pessoa.endereco = { ...val, atual: true }
        this.changed()
      },

      getDados () {
        this.formGenitor = {...this.genitor}
        this.formGenitor.pessoa = {...this.genitor.pessoa}
        if (this.formGenitor.filiacao) this.formGenitor.filiacao = this.genitor.filiacao.map(avo => { return {...avo}})

        if (this.genitor.filho) this.formGenitor.filho = {...this.genitor.filho}

        //if (!this.formGenitor.pessoa.nome) this.init()
        if (this.formGenitor.pessoa.uf) this.ufChanged(this.formGenitor.pessoa.uf)
        if (this.formGenitor.pessoa.data_nascimento) this.calculateAge()

        if (!this.formGenitor.filiacao || !this.formGenitor.filiacao.length) {
          this.formGenitor.filiacao = [
            {nome: ''},
            {nome: ''}
          ]
        }

        if (this.formGenitor.filiacao.length === 1) {
          this.formGenitor.filiacao.push({nome: ''})
        }

        if (!this.formGenitor.localOcorrenciaFalecimento) {
          this.formGenitor.localOcorrenciaFalecimento = {
            tipo: 'OUTRO',
            endereco: {}
          }
        }
      },
      async searchCPF () {
        let cpf = filterMaskedNumber(this.formGenitor.pessoa.cpf)

        if (cpf && cpf.length > 10) {
          const dados = await PessoasService.getPessoaByCPF(cpf)

          if (dados.isEmpty) return

          const { nome, datanascimento, sexo, nomemae } = dados
          const sexos = {
            1: 'M',
            2: 'F'
          }

          if (nomemae && (!this.formGenitor.filiacao.length || !this.formGenitor.filiacao[0].nome)) {
            this.formGenitor.filiacao[0].nome = nomemae
          }

          this.formGenitor.pessoa.nome = nome

          let dataNascimento = filterDate(datanascimento)

          this.formGenitor.pessoa.data_nascimento = dataNascimento.split('/').reverse().join('-')
          this.calculateAge()

          if (!this.propNascimento) {
            this.formGenitor.pessoa.sexo = sexos[sexo] || 'I'
          }
          if ((sexos[sexo] === 'F' || sexos[sexo] === 'M') && (this.propNascimento)) {
            this.formGenitor.pessoa.sexo = sexos[sexo]
          }


        }

        this.formGenitor.pessoa.cpf = this.formGenitor.pessoa.cpf || null

        this.changed()
      },
      nascimentoHandler () {
        this.changed()

        if (!this.formGenitor.pessoa.data_nascimento) {
          this.formGenitor.pessoa.data_nascimento = null
          this.formGenitor.pessoa.idade = 0
        }
        else {
          this.calculateAge()
        }
      },
      setNullAddress () {
        this.formGenitor.pessoa.endereco = {
          atual: true
        }
        this.changed()
      },
      setPredefineAddress () {
        this.formGenitor.pessoa.endereco = {
          ...this.predefineAddress,
          atual: true
        }
        this.changed()
      },

      filterCities (state = null) {
        return state ? this.selectsOptions.cities.filter(city => city.nome === 'Outro' || city.state_id == state.id) : this.selectsOptions.cities
      },

      async ufChanged (uf) {
        if (!uf) {
          this.formGenitor.pessoa.naturalidade = null
          this.changed()
          return
        }
        this.citiesFiltered = []

        for (let state of this.selectsOptions.states) {
          if (state.uf == uf) {
            this.formGenitor.pessoa.uf = state.uf
            this.citiesFiltered = Cidades.filter(cidade => cidade.uf == state.uf)

            this.citiesFiltered.push({nome: 'Outro'})

            if (uf == 'EX') {
              this.formGenitor.pessoa.naturalidade = 'Outro'
            }

            break
          }
        }
      },
      limitText (count) {
        return `e ${count} outras profissões`
      },
      getAddress (endereco) {
        this.formGenitor.pessoa.endereco = endereco
        this.changed()
      },
      getAddressFalecido (address) {
        if (this.formGenitor && this.formGenitor.localOcorrenciaFalecimento) {
          Object.assign(this.formGenitor.localOcorrenciaFalecimento, { endereco: address })
          this.changed()
        }
      },
      getDataFalecimento (data) {
        if (this.formGenitor && this.formGenitor.localOcorrenciaFalecimento) {
          Object.assign(this.formGenitor.localOcorrenciaFalecimento, { data_falecimento: data })
          this.changed()
        }
      },
      changed () {
        setTimeout(() => {
          if (this.formGenitor.pessoa.falecido) {
            this.formGenitor.declarante = false
          }

          if (this.formGenitor.pessoa.naturalidade && this.formGenitor.pessoa.naturalidade !== 'Outro') {
            this.formGenitor.pessoa.naturalidade_declarada = null
          }

          /**
           * Deixamos o nome dos avos maiúsculo desta forma, pois com a diretiva
           * v-uppercase o texto digitado sempre é empurrado para o final
           */
          if (this.formGenitor.filiacao.length) {
            this.formGenitor.filiacao.forEach(filiacao => {
              filiacao.nome = filiacao.nome.toUpperCase()
            })
          }

          this.$emit('changed', this.formGenitor)
        }, 200)
      },
      validateInputs (name) {
        this.$validator.validate(name)
        this.changed()
      },
      formContent (content) {
        const tabGenitores = document.querySelector('.contentGenitor')
        const tabDocumentos = document.querySelector('.contentDocumentos')
        const tabEndereco = document.querySelector('.contentEndereco')
        const tabAavos = document.querySelector('.contentAvos')
        const tabAddressFalecimento = document.querySelector('.addressFalecimento')

        setTimeout(() => {
          switch (content) {
          case 'genitor':
            tabGenitores.focus()

          case 'documentos':
            tabDocumentos.focus()

          case 'endereco':
            tabEndereco.focus()

          case 'avos':
            if (this.propNascimento) {
              tabAavos.focus()
            }

          case 'localOcorrenciaFalecimento':
            tabAddressFalecimento.focus()
          }
        }, 200)

      },
      ocupacaoChanged () {
        this.profissaoPreload = this.genitor.pessoa.ocupacao_declarada
        this.changed()
      },
      updateProfissao (profissao = {}) {
        this.formGenitor.pessoa.ocupacao = profissao
        this.formGenitor.pessoa.ocupacao_codigo = profissao.codigo
        this.changed()
      },

      getDocumentos (documento) {
        if (!this.formGenitor.pessoa.documentos) {
          this.formGenitor.pessoa.documentos = []
        }
        
        this.formGenitor.pessoa.documentos.push(documento)

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 500)

        this.changed()
      },
      removeDocumento (documento) {
        this.formGenitor.pessoa.documentos.splice(documento.localId, 1)
        this.$emit('removeDocumento', documento)
        this.changed()
      },
      calculateAge () {
        this.formGenitor.pessoa.idade = moment().diff(moment(this.formGenitor.pessoa.data_nascimento), 'years')
      },
      changeNacionalidade (nacionalidade) {
        this.formGenitor.pessoa.nacionalidade = nacionalidade
        this.changed()
      },
      deleteAddress (endereco) {
        this.$emit('removeEndereco', endereco)
        this.changed()
      },
      updateAdresses (endereco) {
        this.formGenitor.pessoa.endereco = endereco
        this.changed()
      },
      clearAvo (avo, index) {
        avo.nome = ''

        if (avo.avo_id) {
          this.$emit('deleteAvo', avo.avo_id)
          this.formGenitor.filiacao[index] = {nome: ''}
        }

        this.changed()
      },
      addAvo () {
        if (this.disableButton()) return

        this.formGenitor.filiacao.push({nome: ''})

        setTimeout(() => {
          const input = document.querySelector(`#nome-avo-${this.formGenitor.filiacao.length - 1}`)

          if (input) input.focus()
        }, 100)
      },
      disableButton () {
        const semNome = this.formGenitor.filiacao.filter(avo => !avo.nome)

        if (semNome.length) return true

        return false
      },
      countAvos () {
        const preenchidos = this.formGenitor.filiacao.filter(avo => avo.nome)

        if (preenchidos.length) return preenchidos.length

        return 0
      },
      controlEvent () {
        const addEvent = () => {
          setTimeout(() => {
            const abas = document.querySelectorAll('.nav-link')
            const btnSubmit = document.querySelector('#btn-submit-genitor')
            const btnCancel = document.querySelector('#btn-cancel-genitor')

            if (abas.length) {
              abas.forEach(aba => {
                aba.onkeydown = nextAba
              })
            }

            if (btnSubmit) {
              btnSubmit.onkeydown = firstAba
            }

            if (btnCancel) {
              btnCancel.onkeydown = firstAba
            }
          }, 400)
        }

        const nextAba = (event) => {

          if (event.key != 'Tab' && event.key != 'Enter') return

          const abas = document.querySelectorAll('.nav-link')

          const genitores = document.querySelector('.contentGenitor')
          const documentos = document.querySelector('.contentDocumentos')
          const endereco = document.querySelector('.contentEndereco')
          const avos = document.querySelector('.contentAvos')
          const localFalecimento = document.querySelector('.addressFalecimento')

          const abasArr = Array.from(abas)

          const index = abasArr.findIndex(aba => aba.id == event.target.id)

          if (index != -1 && index != abasArr.length - 1 && event.key == 'Tab') {
            setTimeout(() => {
              abas[index + 1].focus()
            }, 100)
          }

          if (event.key == 'Enter') {
            setTimeout(() => {
              const abaSelected = document.querySelector('.nav-link.active.Genitor--tab-active')
              const indexSelected = abasArr.findIndex(aba => aba == abaSelected)

              switch (indexSelected) {
              case 0:
                genitores.focus()

              case 1:
                documentos.focus()

              case 2:
                endereco.focus()

              case 3:
                if (this.propNascimento) {
                  avos.focus()
                }
                else if (!!this.formGenitor.pessoa.falecido ) {
                  localFalecimento.focus()
                }
              case 4:
                if (this.propNascimento) {
                  localFalecimento.focus()
                }
              }

            }, 200)
          }
        }

        const firstAba = (event) => {
          if (event.key != 'Tab') return

          const formGenitor = document.querySelector('.Genitor-border')
          const abas = formGenitor.querySelectorAll('.nav-link')
          const btnSubmit = document.querySelector('#btn-submit-genitor')

          if (abas) {
            if (event.target.id == 'btn-cancel-genitor' && (btnSubmit && btnSubmit.disabled) || event.target.id == 'btn-submit-genitor') {
              setTimeout(() => {

                const formGenitor = document.querySelector('.Genitor-border')
                const abas = formGenitor.querySelectorAll('.nav-link')
                const abasArr = Array.from(abas)

                // Selecionando os primeiros campos de cada aba
                const firstAscendente = document.querySelector('#nome-avo-0')
                const firstInputDocumento = document.querySelector('.selectDocumentos')
                const firstEnderecoDisponivel = document.querySelector('.endereco-0')
                const firstInputEndereco = this.enderecoRegistrado ? document.querySelector('.novo-enderecos') : document.querySelector('.foraBrasil')

                // Obtendo a posição do index para focar no primeiro input do formulário que estiver aberto
                const abaSelected = document.querySelector('.nav-link.active.Genitor--tab-active')
                const indexSelected = abasArr.findIndex(aba => aba == abaSelected)

                switch (indexSelected) {
                case 0:
                  this.$refs.cpf_genitor.focus()

                case 1:
                  firstInputDocumento.focus()

                case 2:
                  if (this.enderecosDisponiveis.length) {
                    firstEnderecoDisponivel.focus()
                  }
                  else {
                    firstInputEndereco.focus()
                  }

                case 3:
                  if (this.propNascimento) {
                    firstAscendente.focus()
                  }
                }
              }, 100)
            }
          }
        }

        return { addEvent, nextAba, firstAba }
      },
      changeFalecido () {
        setTimeout(() => {
          this.formGenitor.pessoa.falecido = !this.formGenitor.pessoa.falecido

          this.changed()
          this.controlEvent().addEvent()
        }, 200)
      },

      changeDeclarante () {
        setTimeout(() => {
          this.formGenitor.declarante = !this.formGenitor.declarante

          this.changed()
        }, 200)
      }
    },
  }
</script>

<style lang="scss">
  @import '../../../../scss/_utilities/_exports';
  .FormGenitor {
    &--tabDisabled {
      background-color: $color-gray-light;
      border-bottom: 1px solid $sinoreg-blue !important;
      color: white !important;
      fill: white !important;
    }
  }

  .Genitor {
    & .nav-link {
      border: 1px solid $sinoreg-blue !important;
      color: $color-black;
      font-size: pxToRem(15);
      border-top-left-radius:0;
      border-top-right-radius:0;
    }

    &--tab-active {
      background-color: $sinoreg-blue !important;
      border: 1px solid $sinoreg-blue !important;
      color: white !important;
      fill: white !important;
      font-weight: bold;
    }

    &-border ul.nav {
      border-bottom: 3px solid $sinoreg-blue !important;
    }

    &-border ul.nav > li.nav-item > a {
      border: 1px solid #696969;
      border-bottom: 0;
      border-top-left-radius:5px;
      border-top-right-radius:5px;
      color: black;
      font-size: pxToRem(15);
    }

    &-border ul.nav > li.nav-item > a:hover {
      border: 1px solid #696969;
      border-bottom: 0;
      border-top-left-radius:5px;
      border-top-right-radius:5px;
    }
  }

  .Avo {
    &-body {
      margin-top: 20px;
    }

    &-title {
      margin: 0;
    }

    &-hr {
      margin: 0;
      padding: 0;
      background:#696969;
    }

    &-label {
      margin: 0 0 0 0;
      font-size: 16px;
    }

    &-label-nome {
      margin: 1.5px 0 1.5px 0;
      font-size: 16px;
      color: #373a3c
    }

    &-icon-eraser {
      fill: #ff0000;
      width: 20px;
      height: 20px;
      transition: fill 0.2s;
    }

    &-btn-eraser-avo:hover > [class*=Avo-icon-eraser] {
      fill: #fff;
    }

    &-icon-add {
      fill: #1c7af5;
      width: 20px;
      height: 20px;
      transition: fill 0.2s;
    }

    &-btn-add-avos {
      width: 100%;
      margin: 0 0 45px 0;
    }

    &-btn-add-avos:hover > [class*=Avo-icon-add] {
      fill: #fff;
    }

    &-btn-add-avos:hover:disabled [class*=Avo-icon-add] {
      fill: #1c7af5;
    }
  }
</style>
